import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'subscriptionBillingType',
  standalone: false,
})
export class SubscriptionBillingTypePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    return (
      this.translate.instant(`enums.subscriptionBillingType.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
